import React from 'react'
import { AppBar, Toolbar, IconButton, Badge, Typography } from '@material-ui/core'
import { ShoppingCart } from '@material-ui/icons';
import { Link, useLocation } from "react-router-dom"
import logo from '../../assests/commerce.png'
import useStyles from './styles'
const Navbar = ({ totalItems }) => {
    const classes = useStyles();
    const location = useLocation();



    return (
        <>
            <AppBar position='fixed' className={classes.appBar} color="inherit">
                <Toolbar>
                    <Typography variant="h5" component={Link} to="/" className={classes.title} color="inherit">
                        <img src={logo} alt='bagels are good' height="25px" className={classes.image} />
                        Bagels are Good
                    </Typography>
                    <div className={classes.grow}></div>
                    {location.pathname === '/store' && (
                        <div className={classes.button}>
                            <IconButton component={Link} to="/cart" aria-label='Show cart items' color="inherit">
                                <Badge badgeContent={totalItems} color="secondary">
                                    <ShoppingCart />
                                </Badge>
                            </IconButton>
                        </div>)}
                </Toolbar>
            </AppBar>
        </>
    )
}

export default Navbar